// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"47400e9b","874":"47400e9b"}[chunkId] + ".chunk.css";
};